// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8ef3fb21","598":"dd1f8604","703":"7a5c1afc","710":"925f3eaf"}[chunkId] + ".chunk.js";
};